export enum ItemType {
  BUG = 'Bug',
  FEATURE = 'Feature'
}

export enum BugStatus {
  REPORTED = 'Gemeld',
  BACKLOG = 'Backlog',
  IN_PROGRESS = 'In behandeling',
  TESTING = 'Testing',
  RESOLVED = 'Opgelost',
  CLOSED = 'Gesloten',
  PARKED = 'Geparkeerd',
}

export enum BugPriority {
  LOW = 'Laag',
  MEDIUM = 'Normaal',
  HIGH = 'Hoog',
  CRITICAL = 'Kritiek'
}

export interface BugReportScreenshot {
  fileId: string;
  fileUrl: string;
  fileName: string;
}

export interface BugReport {
  id: number;
  title: string;
  description: string;
  type: ItemType;
  status: BugStatus;
  priority: BugPriority;
  tags: string[];
  screenshots: BugReportScreenshot[];
  sharePointFolderId?: string;
  sharePointFolderUrl?: string;
  reportedBy: string;
  assignedTo?: string;
  epicId?: number | null;
  epic?: {
    id: number;
    title: string;
    status: string;
  } | null;
  parkReason?: string;
  createdAt: Date;
  updatedAt: Date;
  userAgent?: string;
  url?: string;
}

export interface CreateBugReportDto {
  title: string;
  description: string;
  type?: ItemType;
  priority?: BugPriority;
  tags?: string[];
  userAgent?: string;
  url?: string;
}

